import React, { useState } from "react";
import IQbd_Custom_Field from "../../../../../../models/IQbd_Custom_Field";
import { OwFnInput } from "../../../../../shared/OwFnInput/OwFnInput";
import QbdCustomFieldsTypeEnum from "../../../../../../models/QbdCustomFieldsTypeEnum";
import OwLabel from "../../../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../../../shared/OwSelectOption/OwSelectOption";
import OwCheckbox from "../../../../../shared/OwCheckbox/OwCheckbox";

type Props = {
    field: IQbd_Custom_Field;
    updateFn: (field: IQbd_Custom_Field) => void;
    deleteFn: (field: IQbd_Custom_Field) => void;
    fieldTypeOptions: { value: QbdCustomFieldsTypeEnum; title: string }[];
    cfItemDestPropOptions: { value: string; title: string }[];
    cfCustomerDestOptions: { value: string; title: string }[];
};

export const QbdCustomFieldRow = (props: Props) => {
    const [field, setField] = useState(props.field);
    const [isEditMode, setIsEditMode] = useState(false);

    const cancelEdit = () => {
        setIsEditMode(false);
    };

    const saveRow = () => {
        props.updateFn(field);
    };

    const confirmDelete = () => {};

    const startEdit = () => {
        setIsEditMode(true);
    };

    const handleChange = (e: any) => {
        setField({ ...field, [e.target.name]: e.target.value });
    };

    return (
        <tr className={"QbdCustomFieldRow"}>
            <td>
                {isEditMode ? (
                    <div>
                        <i className={"fas fa-times-alt text-danger"} onClick={cancelEdit} />
                        <i className={"fas fa-check text-success ms-2"} onClick={saveRow} />
                    </div>
                ) : (
                    <div>
                        <i className={"fas fa-trash-alt text-danger"} onClick={confirmDelete} />
                        <i className={"fas fa-pencil-alt text-primary ms-2"} onClick={startEdit} />
                    </div>
                )}
            </td>
            <td>
                {isEditMode ? (
                    <div>
                        <OwFnInput fn={handleChange} name={"name"} value={field.name} placeholder={"name"} />
                    </div>
                ) : (
                    field.name
                )}
            </td>
            <td>
                {isEditMode ? (
                    <div>
                        <div>
                            <OwLabel title={"type"} />
                            <OwSelectOption
                                fn={handleChange}
                                name={"type"}
                                valueProp={"value"}
                                titleProp={"title"}
                                options={props.fieldTypeOptions}
                            />
                        </div>
                    </div>
                ) : (
                    field.type
                )}
            </td>
            <td>
                {isEditMode ? (
                    <div>
                        <OwLabel title={"destination_property"} />
                        <OwSelectOption
                            fn={handleChange}
                            name={"cfDestProp"}
                            valueProp={"value"}
                            titleProp={"title"}
                            options={
                                field.type
                                    ? field.type === QbdCustomFieldsTypeEnum.ITEMS
                                        ? props.cfItemDestPropOptions
                                        : props.cfCustomerDestOptions
                                    : []
                            }
                        />
                    </div>
                ) : field.display_only ? (
                    "N/A"
                ) : (
                    field.dest_prop
                )}
            </td>
            <td>
                {isEditMode ? (
                    <div>
                        <OwCheckbox
                            fn={handleChange}
                            name={"display_only"}
                            checked={field.display_only}
                            truthyVal={true}
                            falsyVal={false}
                        />
                    </div>
                ) : field.display_only ? (
                    "Yes"
                ) : (
                    "No"
                )}
            </td>
        </tr>
    );
};
